import Vue from 'vue'
import VueRouter from 'vue-router'

import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
/* CORE */

import app from './routes/app'
/* ADMIN:CORE */
import users from './routes/Admin/Core/Users'
import userTypes from './routes/Admin/Core/User_types'
/* ADMIN:TRADER */
import coins from './routes/Admin/Trader/Coins'
import indicators from './routes/Admin/Trader/Indicators'
import indicatorPerformance from './routes/Admin/Trader/IndicatorPerformance'
import entryRouter from './routes/Admin/Trader/EntryRouter'
import edges from './routes/Admin/Trader/Edges'
import quickGain from './routes/Admin/Trader/QuickGain'
import scriptSignal from './routes/Admin/Trader/ScriptSignal'
import fleet from './routes/Admin/Trader/Fleet'
import profitStrategies from './routes/Admin/Trader/ProfitStrategies'
import positionGuardian from './routes/Admin/Trader/PositionGuardian'
import strategyDoctor from './routes/Admin/Trader/StrategyDoctor'
import testStudio from './routes/Admin/Trader/TestStudio'
import signalLauncher from './routes/Admin/Trader/SignalLauncher'
import signalAutomation from './routes/Admin/Trader/SignalAutomation'
import hedgePairTrading from './routes/Admin/Trader/HedgePairTrading'
import rescanJobs from './routes/Admin/Trader/RescanJobs'
import bots from './routes/Admin/Trader/Bots'
import targets from './routes/Admin/Trader/Targets'
/* ADMIN:ACCOUNT */
import apiKeys from './routes/Admin/Account/ApiKeys'
/* ADMIN:REPORTS */
import reports from './routes/Admin/Reports/Reports'
/* ADMIN:FINANCE */
import finance from './routes/Admin/Finance/Finance'
/* ADMIN:SYSTEM */
import systemConsole from './routes/Admin/System/SystemConsole'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'home' } },
    ...app,
    ...users,
    ...userTypes,
    ...coins,
    ...indicators,
    ...indicatorPerformance,
    ...entryRouter,
    ...edges,
    ...quickGain,
    ...scriptSignal,
    ...fleet,
    ...profitStrategies,
    ...positionGuardian,
    ...strategyDoctor,
    ...testStudio,
    ...signalLauncher,
    ...signalAutomation,
    ...hedgePairTrading,
    ...rescanJobs,
    ...bots,
    ...targets,
    ...apiKeys,
    ...reports,
    ...finance,
    ...systemConsole,

    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()

  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'auth-login' })

    // If logged in => not authorized
    return next({ name: 'misc-not-authorized' })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
  }

  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
